import { useSelector } from 'react-redux';
import { TechnicalSupportEntry } from '../../../common/technical-support/model/TechnicalSupportEntry';
import { getTechnicalSupportWithFallback } from '../../../common/util/content/getTechnicalSupportWithFallback';
import { getCurrentUserSelector } from '../../security/ducks/currentUserSelector';

export const useTechnicalSupportContactDetails = (): TechnicalSupportEntry => {
  const user = useSelector(getCurrentUserSelector);

  return getTechnicalSupportWithFallback(user.localization.countryCode);
};
